import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UrlnavService {
  private dataUrl = new Subject<any>()
  data$ = this.dataUrl.asObservable()
  constructor(private ngZone: NgZone) { }

  sendDataUrl(data: any){
   return this.ngZone.run(() => {
      this.dataUrl.next(data)
    } )
  }
}
